/** Tokens visuais — lista de inscritos (mesmo padrão dos recebimentos) */
export const INSCRITOS_ACCENT = "#F96030";
export const INSCRITOS_INK = "#1a2035";
export const INSCRITOS_ACCENT_SOFT = "rgba(249, 96, 48, 0.08)";

export const inscritosToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${INSCRITOS_ACCENT}`,
};

export const inscritosSectionSx = {
  p: { xs: 1.5, sm: 2 },
  borderRadius: 2,
  border: "1px solid",
  borderColor: "grey.200",
  bgcolor: "background.paper",
};

export const inscritosFilterChipSx = (active: boolean) => ({
  fontWeight: active ? 700 : 500,
  ...(active
    ? {
        bgcolor: INSCRITOS_ACCENT,
        color: "#fff",
        borderColor: INSCRITOS_ACCENT,
        "&:hover": { bgcolor: "#e04a1a" },
      }
    : {
        borderColor: "grey.300",
        color: "text.secondary",
        "&:hover": { bgcolor: "grey.50" },
      }),
});

export const inscritosFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 1.5,
    bgcolor: "background.paper",
  },
};
